<template>
  <MultipleRowText v-if="showAll" :value="value"></MultipleRowText>
  <DialogContent v-else :title="title">
    <template #trigger="{ open }">
      <div class="preview-text" :title="value" :style="{ '--row': maxRow }" @click.stop="open">{{ value }}</div>
    </template>
    <MultipleRowText :value="value"></MultipleRowText>
  </DialogContent>
</template>

<script>
import { Vue, Component, Prop } from 'vue-property-decorator';
import DialogContent from '@/components/dialog-content.vue';
import MultipleRowText from '@/components/multiple-row-text.vue';

@Component({
  components: {
    DialogContent,
    MultipleRowText,
  },
})
export default class DialogText extends Vue {
  @Prop({ type: String, default: '' }) value;
  @Prop({ type: Number, default: 1 }) maxRow;
  @Prop({ type: String, default: '查看详情' }) title;
  @Prop({ type: Boolean, default: false }) showAll;
}
</script>

<style scoped lang="scss">
.preview-text {
  @include text-overflow($row: var(--row));
  cursor: pointer;
  white-space: pre-wrap;
  text-align: left;
}
</style>
